export const grey = '#d5d7e1';
export const beige = '#e1d7d5';
export const green = "#b6c4a2";
export const blue  = "#bee1f1";
export const creme = "#ead2ac";
export const pink = "#c4c6e7";
export const purple = "#baacbd";